import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaiwan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_943)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4348 7.02287L8.9692 7.7123L9.74958 9.13163L8.15822 8.82713L7.95652 10.4348L6.84811 9.25243L5.73961 10.4348L5.538 8.82713L3.9466 9.13154L4.72697 7.71221L3.26147 7.02287L4.72702 6.33357L3.9466 4.91419L5.53796 5.21865L5.73966 3.61102L6.84811 4.7934L7.95656 3.61102L8.15822 5.21865L9.74963 4.91419L8.9692 6.33362L10.4348 7.02287Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.84836 9.25636C8.08202 9.25636 9.08209 8.25629 9.08209 7.02263C9.08209 5.78897 8.08202 4.78889 6.84836 4.78889C5.6147 4.78889 4.61462 5.78897 4.61462 7.02263C4.61462 8.25629 5.6147 9.25636 6.84836 9.25636Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.84816 8.21311C6.19186 8.21311 5.65796 7.67916 5.65796 7.02286C5.65796 6.36656 6.19191 5.83261 6.84816 5.83261C7.50446 5.83261 8.03841 6.36656 8.03841 7.02286C8.03836 7.67916 7.50436 8.21311 6.84816 8.21311Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_943",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTaiwan;
